import { Observable } from 'rxjs/Observable'
import { combineEpics } from 'redux-observable'

import * as actions from './actions'
import { api } from './api'

function fetchAttachments(action$) {
  return action$
    .ofType(actions.fetchAttachments.toString())
    .pluck('payload')
    .mergeMap(ids => {
      return api
        .fetch(ids)
        .map(actions.receiveAttachments)
        .catch((err) => Observable.of(actions.fetchAttachmentsFailed({ ids, err })))
    })
}

function uploadAttachment(action$) {
  return action$
    .ofType(actions.uploadAttachment.toString())
    .pluck('payload')
    .mergeMap(({ conversationId, file, ticketId }) => {
      return api
        .upload(conversationId, file)
        .map(attachment => actions.uploadAttachmentSuccess({ attachment, ticketId }))
        .startWith(actions.uploadAttachmentPending({ ticketId }))
        .catch(() => Observable.of(actions.uploadAttachmentFailed({ ticketId })))
    })
}

export const epic = combineEpics(fetchAttachments, uploadAttachment)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/message/attachment/epic.js